import { memo } from 'react';

// 注意：这里我们直接使用普通的 div，因为 Ant Design 没有完全对应的 Box 组件
// 我们可以使用 styled-components 或者直接使用 div + style 属性

interface AvatarShapeProps {
  style?: React.CSSProperties;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

function AvatarShape({ style, ...other }: AvatarShapeProps) {
  return (
    <div
      style={{
        color: '#fff', // 对应原来的 background.paper
        ...style,
      }}
      {...other}
    >
      <svg
        width={144}
        height={62}
        fill="none"
        viewBox="0 0 144 62"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m111.34 23.88c-10.62-10.46-18.5-23.88-38.74-23.88h-1.2c-20.24 0-28.12 13.42-38.74 23.88-7.72 9.64-19.44 11.74-32.66 12.12v26h144v-26c-13.22-.38-24.94-2.48-32.66-12.12z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    </div>
  );
}

export default memo(AvatarShape);
